import ReactPhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css'
import ru from 'react-phone-input-2/lang/ru.json';
import React, { useEffect, useState } from 'react';

const PhoneInput = (props) => {
  const { value, onChange, showValidation, ...passedProps } = props;

  const [phoneValue, setPhoneValue] = useState(value);

  useEffect(() => setPhoneValue(value), [value]);

  const handlePastePhone = (e) => {
    //Заменяем первый символ телефона '8' на международный код России '7', но только при вставке телефона из клипборда. Если телефон начинается на 8 или 7 и имеет 11 символов (т.е. полный номер России включая международный код) то копирование с заменой существующего содержимого input. Поскольку по умолчанию там стоит +7 и при добавлении из-за этого 7 дублируюется а последняя цифра номера проглатывается.
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').trim();
    if (pasted && (pasted[0] === '8' || (pasted[0] === '7' && pasted.length === 11))) {
      const newValue = '7' + pasted.substr(1);
      setPhoneValue(newValue);
      onChange(newValue);
      e.preventDefault();
    }
  };

  const inputStyle = {
    paddingLeft: '.9rem',
  };
  if (showValidation) {
    inputStyle.borderColor = '#f1556c';
  }

  return (
    <ReactPhoneInput
      placeholder="+7 (915) 123-23-23"
      country="ru"
      localization={ru}
      inputProps={{
        onPaste: handlePastePhone,
      }}
      buttonStyle={{ display: 'none' }}
      inputStyle={inputStyle}
      value={phoneValue}
      onChange={(value) => onChange(value)}
      {...passedProps}
    />
  );
  //Если будет желание включить кнопку с флажком, есть интересная опция preferredCountries={['ru', 'by', 'ua']} - выбранные страны выводятся всегда сверху списка.
};

export default PhoneInput;
